import React, { Component } from 'react'
import { connect } from 'react-redux';
import { setFilter } from '../../actions/filters'

// UI component for dropdown.
const NumericDropdown = ({label,value,handleChange}) => (
    <span>
        <label>
            {`Where ${label} `}
            <select value={value} onChange={handleChange}>
                <option value="===">is equal to</option>
                <option value="!==">is not equal to</option>
                <option value="<">is less than</option>
                <option value=">">is greater than</option>
            </select>
        </label>
    </span>
)

// Single input UI
const SingleInput = ({value,input1HandleChange}) => (
    <span>
        <input type="number" 
            onChange={input1HandleChange}
            value={value}
        />
    </span>
)

// Double input UI
const DoubleInput = ({value1, 
    value2, 
    input1HandleChange, 
    input2HandleChange}) => (
    <span>
        <input type="number" 
            onChange={input1HandleChange}
            value={value1}
        />
        { ' and '}
        <input type="number" 
            onChange={input2HandleChange}
            value={value2}
        />
    </span>
)

// Actual class
class NumericFilter extends Component{
    constructor(props){
        super(props)
        this.state = {
            condition: ">",
            input1: 0,
            input2: 0
        }
        this.input1HandleChange = this.input1HandleChange.bind(this)
        this.input2HandleChange = this.input2HandleChange.bind(this)
        this.handleNumericDropdownChange = this.handleNumericDropdownChange.bind(this)
    }

    handleNumericDropdownChange(event){
        this.setState({
            condition: event.target.value
        })
    }

    input1HandleChange(event){
        this.setState({
            input1: event.target.value
        })
    }

    input2HandleChange(event){
        this.setState({
            input2: event.target.value
        })
    }

    componentDidUpdate(){
        this.bindToState()
    }

    bindToState(){
        let filter = {}
        filter[this.props.filterName] = {
            type: "number",
            condition: this.state.condition,
            value1: this.state.input1,
            value2: this.state.input2
        }
        this.props.dispatch(setFilter(
            this.props.id,
            filter
        ))
    }

    render(){
        let cx = this.props.condition
        let i1 = this.props.value1
        let i2 = this.props.value2
        let lb = this.props.filterName
        return(
            <div>
                <NumericDropdown 
                    label={lb}
                    value={cx}
                    handleChange={this.handleNumericDropdownChange}
                />
                {
                    ( cx === '>value1&&<value2' || cx === 'value1&&>value2' ) ?
                    <DoubleInput 
                        value1={i1} 
                        value2={i2}
                        input1HandleChange={this.input1HandleChange}
                        input2HandleChange={this.input2HandleChange}
                    /> : 
                    <SingleInput 
                        value={i1} 
                        input1HandleChange={this.input1HandleChange}
                    />
                }
            </div>
        )
    }
}

export default connect()(NumericFilter)


// WEBPACK FOOTER //
// ./src/components/filters/numericFilter.js